const LATEST_EDITING_PATIENT_ID_KEY = 'latest_editing_patient_id';

const getStorageKey = (tenant?: string, clinicNumber?: string) =>
  tenant && clinicNumber
    ? `${LATEST_EDITING_PATIENT_ID_KEY}:${tenant}:${clinicNumber}`
    : tenant
      ? `${LATEST_EDITING_PATIENT_ID_KEY}:${tenant}`
      : LATEST_EDITING_PATIENT_ID_KEY;

export const setLatestEditingPatientId = (
  tenant: string | undefined,
  patientId: number | string,
  clinicNumber?: string
) => {
  if (typeof window === 'undefined') {
    return;
  }

  const normalizedId = Number(patientId);
  if (!Number.isInteger(normalizedId) || normalizedId <= 0) {
    return;
  }

  window.localStorage.setItem(getStorageKey(tenant, clinicNumber), String(normalizedId));
};

export const getLatestEditingPatientId = (tenant?: string, clinicNumber?: string): number | null => {
  if (typeof window === 'undefined') {
    return null;
  }

  const value = window.localStorage.getItem(getStorageKey(tenant, clinicNumber));
  if (!value) {
    return null;
  }

  const parsed = Number(value);
  if (!Number.isInteger(parsed) || parsed <= 0) {
    return null;
  }

  return parsed;
};

export const clearLatestEditingPatientId = (tenant?: string, clinicNumber?: string) => {
  if (typeof window === 'undefined') {
    return;
  }

  window.localStorage.removeItem(getStorageKey(tenant, clinicNumber));
};
